export const COOKIE_CONSENT_STORAGE_KEY = "inari_cookie_consent_v1";

export const COOKIE_CONSENT_BANNER_TEXT =
  "Используя данный сайт, вы даете согласие на использование файлов cookie, помогающих нам сделать его удобнее для вас.";

export const COOKIE_POLICY_LINK_TEXT = "Подробнее";

export const SECURITY_POLICY_PAGE_TITLE =
  "Политика в области обработки и защиты персональных данных";

export const SECURITY_POLICY_ROUTE = "/security-policy";

export { SECURITY_POLICY_FULL_TEXT } from "../data/securityPolicyFullText";
